// extracted by mini-css-extract-plugin
export default {"customDropdownIndicator":"SearchLocation_customDropdownIndicator__zh0QT","isFocused":"SearchLocation_isFocused__0+aBU"};